import { hashKey, QueryCache } from "@tanstack/react-query";

import { DATA_LAYER_SCOPES } from "seneca-common/features/analytics";
import { pushGlobalValuesToDataLayer } from "seneca-common/features/analytics/gtm";
import { fetchMySchoolInfoQueryOptions } from "seneca-common/features/schools/service/queries";

const queryCache = new QueryCache();

const addSchoolInfoToDataLayer = (event: any) => {
  if (event.type === "updated" && event.action.type === "success") {
    if (
      event.query.queryHash ===
        hashKey(fetchMySchoolInfoQueryOptions().queryKey) &&
      !!event.action.data
    ) {
      pushGlobalValuesToDataLayer({
        [DATA_LAYER_SCOPES.SCHOOL]: {
          schoolId: event.action.data.schoolId,
          name: event.action.data.name
        }
      });
    }
  }

  if (event.type === "removed") {
    if (
      event.query.queryHash ===
      hashKey(fetchMySchoolInfoQueryOptions().queryKey)
    ) {
      pushGlobalValuesToDataLayer({
        [DATA_LAYER_SCOPES.SCHOOL]: {
          schoolId: null,
          name: null
        }
      });
    }
  }
};

queryCache.subscribe(addSchoolInfoToDataLayer);

export default queryCache;
